import React, { Component } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Split from "../components/split"
import { injectIntl } from "gatsby-plugin-intl"

class IndexPage extends Component {
  render() {
    const { data, intl: { locale } } = this.props

    const localizedData = data.allFile.edges.filter(({ node }) => {
      return node.childMarkdownRemark.frontmatter.locale === locale
    })

    return (
      <Layout>
        <SEO lang={locale} />
        <Split data={localizedData} />
      </Layout>
    )
  }
}

export default injectIntl(IndexPage)

export const query = graphql`
  query chapters {
    allFile(
      filter: {
        internal: { mediaType: { eq: "text/markdown" } }
        sourceInstanceName: { eq: "chapters" }
      }
    ) {
      edges {
        node {
          childMarkdownRemark {
            id
            frontmatter {
              title
              color
              order
              key
              locale
            }
            htmlAst
          }
        }
      }
    }
  }
`
